import { isDev } from "src/constants/env"
import { useMinutQuery } from "src/hooks/minutQuery"

export const apiKeyKeys = {
  apiKeys() {
    return ["api_keys"] as const
  },
}

export function useFetchApiKeys({
  options,
}: {
  options?: {
    enabled?: boolean
  }
}) {
  const response = useMinutQuery<`/third-party-configuration`, 403>({
    queryKey: apiKeyKeys.apiKeys(),
    queryPath: `/third-party-configuration`,
    options,
  })

  return response.data
}

export function useFetchGoogleMapsApiKey({
  options,
}: {
  options?: {
    enabled?: boolean
  }
}) {
  const apiKeys = useFetchApiKeys({ options })

  if (isDev) {
    return import.meta.env.REACT_APP_GOOGLE_MAPS_API_KEY
  }

  return (
    apiKeys?.apiKeys.find(
      (key) => key.id === "FIRST_PARTY_CLIENT_GOOGLE_MAPS_API_KEY"
    )?.value ?? ""
  )
}
